module.exports = "/lucky-balls/img/drawnballs/purple.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drawnballs/purple.png
// module id = 1013
// module chunks = 0